import React from 'react';
import { NavLink } from 'react-router-dom';
import { withLocation } from './../Common/withLocation'; // Importa el HOC que creaste



class Banner extends React.Component {

    render() {
    // 1. Acceder a la ruta inyectada por el HOC
    const currentPath = this.props.location.pathname;

    // 2. Definir las rutas que deben ocultar el div
    const hiddenRoutes = ['/', '/registro', '/pago'];

    //console.info(this.props.description);
    //console.info(this.props.title);

    // 3. Lógica para determinar si el Navbar debe ocultarse {this.props.title} 
    const shouldHideNavbar = hiddenRoutes.includes(currentPath);        
        return (
            <>
                <div className="sx-bnr-inr overlay-wraper bg-parallax bg-top-center" data-stellar-background-ratio="0.5" style={{ backgroundImage: 'url(' + this.props.bgimage + ')' }}>
                    <div className="overlay-main bg-black opacity-07" />
                    <div className="container">
                        <div className="sx-bnr-inr-entry">
                            <div className="banner-title-outer">
                                <div className="banner-title-name ">
                                    <h2 className="m-tb0"><br /> 
                                        

                                        {this.props.title1} <br/>{this.props.title2} 
                                    
                                    </h2>                                
                                    <p>
                                        {this.props.description.texto}
                                    </p>
                                        {this.props.description.texto2}
                                </div>
                               
                            </div>
                            
                            {/* BREADCRUMB ROW */}
                            <div>
                                <ul className="sx-breadcrumb breadcrumb-style-2">
                                <li><NavLink to={"/"}>Home</NavLink></li>
                                    <li>{this.props.pagename}</li>
                                </ul>
                            </div>
                            {/* BREADCRUMB ROW END */}
                        </div>

                          
                    </div>
                </div>
            </>
        );
    }
};

//export default Banner;
export default withLocation(Banner);